var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.messageSize
    ? _c("span", { attrs: { "data-test": "scout-history" } }, [
        _c("section", { staticClass: "boss-transmission-history" }, [
          _c("table", { staticClass: "unstriped boss-table" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _c("tr", [
                  _c("td", { staticClass: "boss-table-data-head" }, [
                    _vm._v("送信日時"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass: "boss-table-data",
                      attrs: { "data-test": "send-date" },
                    },
                    [_vm._v(_vm._s(_vm._f("parseDateFormat")(_vm.sendDate(0))))]
                  ),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", { staticClass: "boss-table-data-head" }, [
                    _vm._v("求人"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass: "boss-table-data",
                      attrs: { "data-test": "job-title" },
                    },
                    [_vm._v(_vm._s(_vm.jobTitle))]
                  ),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", { staticClass: "boss-table-data-head" }, [
                    _vm._v("件名"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass: "boss-table-data",
                      attrs: { "data-test": "message-subject" },
                    },
                    [_vm._v(_vm._s(_vm.messageSubject(0)))]
                  ),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", { staticClass: "boss-table-data-head" }, [
                    _vm._v("本文"),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "boss-table-data" }, [
                    _c("div", { staticClass: "boss-send-contents" }, [
                      _c("div", {
                        staticClass: "boss-send-text pega-pre-wrap",
                        attrs: { "data-test": "message-body" },
                        domProps: {
                          innerHTML: _vm._s(_vm.$sanitize(_vm.messageBody(0))),
                        },
                      }),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", { staticClass: "boss-table-data-head" }, [
                    _vm._v("スカウト特典"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "boss-table-data" },
                    _vm._l(_vm.specialFavors(0), function (favor, i) {
                      return _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: {
                                content: _vm.specialFavorBy(favor.id)
                                  .description,
                              },
                              expression:
                                "{ content: specialFavorBy(favor.id).description}",
                            },
                          ],
                          key: i,
                          staticClass: "boss-bonus-check-text boss-check-true",
                          attrs: { "data-test": "favor-" + i },
                        },
                        [_vm._v(_vm._s(favor.name))]
                      )
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _vm.moreHistory
                  ? [
                      _vm._l(_vm.messageSize - 1, function (index) {
                        return [
                          _c("tr", { key: "blank-" + index }, [
                            _c("td", { attrs: { colspan: "2" } }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "tr",
                            {
                              key: "send-date-" + index,
                              attrs: { "data-test": "more-history" },
                            },
                            [
                              _c(
                                "td",
                                { staticClass: "boss-table-data-head" },
                                [_vm._v("送信日時")]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "boss-table-data",
                                  attrs: {
                                    "data-test":
                                      "more-history-send-date-" + index,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("parseDateFormat")(
                                        _vm.sendDate(index)
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("tr", { key: "job-title-" + index }, [
                            _c("td", { staticClass: "boss-table-data-head" }, [
                              _vm._v("求人"),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "boss-table-data" }, [
                              _vm._v(_vm._s(_vm.jobTitle)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("tr", { key: "subject-" + index }, [
                            _c("td", { staticClass: "boss-table-data-head" }, [
                              _vm._v("件名"),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "boss-table-data" }, [
                              _vm._v(_vm._s(_vm.messageSubject(index))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("tr", { key: "body" + index }, [
                            _c("td", { staticClass: "boss-table-data-head" }, [
                              _vm._v("本文"),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "boss-table-data" }, [
                              _c("div", { staticClass: "boss-send-contents" }, [
                                _c("div", {
                                  staticClass: "boss-send-text pega-pre-wrap",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$sanitize(_vm.messageBody(index))
                                    ),
                                  },
                                }),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("tr", { key: "favor-" + index }, [
                            _c("td", { staticClass: "boss-table-data-head" }, [
                              _vm._v("スカウト特典"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "boss-table-data" },
                              _vm._l(
                                _vm.specialFavors(index),
                                function (favor, i) {
                                  return _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: {
                                            content: _vm.specialFavorBy(
                                              favor.id
                                            ).description,
                                          },
                                          expression:
                                            "{ content: specialFavorBy(favor.id).description}",
                                        },
                                      ],
                                      key: i,
                                      staticClass:
                                        "boss-bonus-check-text boss-check-true",
                                      attrs: { "data-test": "more-favor-" + i },
                                    },
                                    [_vm._v(_vm._s(favor.name))]
                                  )
                                }
                              ),
                              0
                            ),
                          ]),
                        ]
                      }),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.messageSize > 1 && !_vm.moreHistory
          ? _c("div", { staticClass: "boss-more-button" }, [
              _c(
                "button",
                {
                  staticClass:
                    "float-center boss-button-center boss-button-large",
                  attrs: { "data-test": "more-history-button" },
                  on: { click: _vm.onMoreHistoryClick },
                },
                [_vm._v("もっと見る")]
              ),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "boss-table-head", attrs: { colspan: "2" } }, [
          _vm._v("スカウト送信履歴"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }